/* global femcare, Swiper */

/**
 * Initializes and controls Swiper sliders for navigating between different safety layers
 * and dynamically updates the active layer image based on user interaction.
 */
femcare.product.safetySection = {
    /**
     * Initializes the safety section.
     */
    init: function () {
        this.$productSafety = $('.product-safety');

        if (this.$productSafety.length) {
            this.$layerImages = this.$productSafety.find('.product-layers__images img');
            this.$productLayers = this.$productSafety.find('.product-layer');
            this.initSliders();
            this.bindLayerEvents();
        }
    },

    /**
     * Initializes the Swiper sliders.
     */
    initSliders: function () {
        this.largeScreenSlider = new Swiper('.product-layers__slider--vertical', {
            spaceBetween: 10,
            slidesPerView: this.$layerImages.length - 1,
            allowTouchMove: false,
            direction: 'vertical',
        });

        this.smallScreenSlider = new Swiper('.product-layers__slider--horizontal', {
            direction: this.getDirection(),
            autoplay: this.getDirection() === 'horizontal' ? false : { delay: 5000 },
            on: {
                resize: function () {
                    this.smallScreenSlider.changeDirection(this.getDirection());
                }.bind(this),
                realIndexChange: function (instance) {
                    var slide = instance.slides[instance.realIndex];
                    var layerId = slide.getAttribute('data-layer-id');
                    this.setLayerImage(layerId);
                }.bind(this),
            },
            breakpoints: {
                300: {
                    centeredSlides: true,
                    slidesPerView: 1.4,
                    spaceBetween: 15,
                    allowTouchMove: true,
                },
            },
            thumbs: {
                swiper: this.largeScreenSlider,
                slideThumbActiveClass: 'active',
            },
        });
    },

    /**
     * Binds click and keydown events to the product layers to ensure accessibility.
     */
    bindLayerEvents: function () {
        this.$productLayers.each(function (index, layer) {
            $(layer).on('click', function () {
                this.handleLayerInteraction(layer, true);
            }.bind(this));

            $(layer).on('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.handleLayerInteraction(layer, true);
                }
            }.bind(this));
        }.bind(this));
    },

    /**
     * Handles the interaction with a product layer (click or key press).
     * @param {HTMLElement} layer - The product layer element interacted with.
     * @param {boolean} stopAutoplay - Whether to stop the autoplay.
     */
    handleLayerInteraction: function (layer, stopAutoplay) {
        var layerId = layer.getAttribute('data-layer-id');
        this.setLayerImage(layerId);

        if (stopAutoplay && this.smallScreenSlider.autoplay.running) {
            this.smallScreenSlider.autoplay.stop();
        }

        this.$productLayers.removeClass('active');
        $(layer).addClass('active');
    },

    /**
     * Sets the active layer image.
     * @param {string} layerId - The ID of the layer image to set as active.
     */
    setLayerImage: function (layerId) {
        this.$layerImages.removeClass('active');
        $('#' + layerId).addClass('active');
    },

    /**
     * Gets the direction of the slider based on the screen size.
     * @returns {string} - The direction ('horizontal' or 'vertical').
     */
    getDirection: function () {
        var activeMediaquery = femcare.shared.util.getMediaqueryState();
        var isSmallScreen = activeMediaquery < femcare.shared.util.mediaqueries.medium;

        return isSmallScreen ? 'horizontal' : 'vertical';
    },
};
